import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BaseSection from '../BaseSection';
import { useGoogleMaps } from '../../../../providers/GoogleMapsProvider';

const LocationSection = ({ city, address, lat, lng, locations }) => {
  const { t } = useTranslation();
  const {
    setIsInitializedMap,
    isOpenModal,
    setMapData,
    toggleModal,
    setMapModalData
  } = useGoogleMaps();
  const coordinates = lat && lng ? { lat, lng } : undefined;

  const setOpenMapData = useCallback(() => {
    setMapData({
      initialLocation: coordinates,
      pinSelected: isOpenModal,
      isMarkerDraggable: false
    });
    setIsInitializedMap(true);
    setMapModalData({
      modalId: 'residence-map'
    });
    toggleModal(true);
  }, [
    setIsInitializedMap,
    setMapModalData,
    coordinates,
    isOpenModal,
    setMapData,
    toggleModal
  ]);

  return (
    <BaseSection>
      <div className="item-location">
        <div className="item-location__address">{`${city}${t(
          'pages.residence.city'
        )}, ${address}`}</div>
        <div
          className="item-location__map"
          role="button"
          onClick={setOpenMapData}
          onKeyPress={setOpenMapData}
          tabIndex={0}
        />
        {locations &&
          locations.map((item, index) => (
            <div key={index} className="item-location__link">
              {item.fullName}
            </div>
          ))}
      </div>
    </BaseSection>
  );
};

LocationSection.propTypes = {
  city: PropTypes.string,
  address: PropTypes.string,
  locations: PropTypes.array,
  lat: PropTypes.number,
  lng: PropTypes.number
};

export default LocationSection;
